import { BsDatabaseFillCheck, BsClipboardDataFill } from "react-icons/bs";
import { FaCode } from "react-icons/fa6";

export const navlinks = [
  {
    title: "Home",
    id: "home",
  },
  {
    title: "About",
    id: "about",
  },
  {
    title: "Projects",
    id: "projects",
  },
  {
    title: "Work Experience",
    id: "work-xp",
  },
  {
    title: "Contact Me",
    id: "contact",
  },
];

export const skills = [
  {
    name: "Programming & Development",
    level: 90,
    icon: <FaCode />,
    attributes: [
      "Frontend Development (React, Remix, Next.js, HTML, CSS, JavaScript)",
      "Backend Development (TortoiseORM, Alembic, Poetry, Node.js, Express.js, MongoDB, Laravel)",
      "API Design, Development, & Integration (Python, PHP, JavaScript)",
      "Deployment & DevOps (Docker, Vercel, Render)",
    ],
  },
  {
    name: "Data Analytics & Engineering",
    level: 85,
    icon: <BsDatabaseFillCheck />,
    attributes: [
      "Data Analysis & Visualization (Qlik Sense, Metabase, Python)",
      "Database Management & Optimization (Oracle, MySQL, PostgreSQL, GaussDB, NoSQL)",
      "Data Warehousing & ETL Pipelines (Apache Doris, Airflow)",
      "Reporting Automations",
      "Apache Kafka",
    ],
  },
  {
    name: "Business Intelligence & Strategy",
    level: 80,
    icon: <BsClipboardDataFill />,
    attributes: [
      "Dashboard Design & Storytelling with Data",
      "KPIs & Metrics Development",
      "Customer Segmentation & Retention Analytics",
      "Telecom Business Intelligence",
    ],
  },
];

export const projects = [
  {
    title: "Valuations Africa Ltd.",
    link: "https://valuationsafrica.mw/",
    image: "/img/valuations-africa.png",
    description:
      "An online platform that provides property valuation services across Africa, leveraging technology to deliver accurate and timely valuations for residential, commercial, and industrial properties.",
  },
  {
    title: "iMORRCS Africa",
    link: "https://imorrcsafrica.com/",
    image: "/img/imorrcs-africa.png",
    description:
      "A comprehensive online platform that offers real estate services across Africa, providing users with tools and resources to buy, sell, and finance properties efficiently.",
  },
  {
    title: "Binge Chills",
    link: "https://binge.lakudzala.space/",
    image: "/img/binge-chills.png",
    description:
      "A movie streaming web application that allows users to browse, search, and watch movies and TV shows online.",
  },
  {
    title: "Binge Chills API",
    link: "https://binge-chills-fastapi.onrender.com/docs",
    image: "/img/binge-chills-api.png",
    description:
      "A RESTful API built with FastAPI that provides movie and TV show data for the Binge Chills web application.",
  },
  {
    title: "The Chill Spot",
    link: "https://thechillspot.onrender.com/",
    image: "/img/the-chillspot.png",
    description:
      "A social media platform that allows users to connect, share content, and engage with a vibrant community.",
  },
  {
    title: "MUTA MW",
    link: "https://mutamw.onrender.com/",
    image: "/img/muta-mw.png",
    description:
      "A web application that provides information and resources about the Malawi Union of Technical and Allied Workers (MUTA), including news, events, and member services.",
  },
  {
    title: "IAM School Manager",
    link: "https://tsinde.com/about/us",
    image: "/img/iamschool.png",
    description:
      "A multitenant school management system that helps schools manage their operations, including student enrollment, attendance, grades, and more.",
  },
  {
    title: "VORTNET Digital",
    link: "https://vortnetdigital.com/",
    image: "/img/vortnet.png",
    description:
      "An IT solutions and services company that provides web development, digital marketing, and IT consulting services to businesses and organizations.",
  },
  {
    title: "VORTNET Online Store",
    link: "https://vortnet.co.uk/",
    image: "/img/vortnet-store.png",
    description: "An e-commerce platform for VORTNET that sells a variety of tech products, including laptops, desktops, accessories, and more.",
  },
];

export const work_xp = [
  {
    title: "Business Intelligence & Data Analyst",
    company: "Telekom Networks Malawi Plc.",
    start_date: "Apr 2023",
    end_date: null,
    duties: [
      "Partnered with U.C. Berkeley and GiveDirectly on a large-scale research project, leading data collection, analysis, and support for AI model training, that supported over 100,000 households in Malawi.",
      "Automated ETL pipelines using Python, PHP, and Airflow, reducing report generation time with 40%.",
      "Developed custom Qlik Sense dashboard for cross-functional teams (Business Segments, Billing, Compliance, Finance) that enhance decision making.",
      "Developed a customer insights portal and its underlying pipelines, empowering shop assistants with a unified view of customer activity enabling targeted cross-selling and enhanced personalized customer service.",
      "Supporting various stakeholders with data extraction and reporting requirements.",
    ],
  },
  {
    title: "Frontend Development Lead (Remote)",
    company: "Valuations Africa Ltd.",
    start_date: "Jan 2025",
    end_date: null,
    duties: [
      "Collaborated with UX designers and backend engineers to convert mockups and wireframes into responsive, interactive, and dynamic web experience.",
      "Conducted code reviews, testing, and optimizations for performance, security, and cross-browser compatibility.",
      "Develop responsive, accessible user interfaces using React, Typescript, and Tailwind CSS.",
      "Implement state management solutions and integrate with RESTful APIs.",
    ],
  },
  {
    title: "Associate Lecturer (Part-time)",
    company: "Malawi University of Business and Applied Sciences",
    start_date: "Feb 2023",
    end_date: null,
    duties: [
      "Delivering engaging lectures and practical sessions to foster student understanding of IT Support.",
      "Contributing to curriculum development and conduct student assessments, mentoring, and evaluations.",
      "Staying updated with industry trends to provide relevant and current knowledge to students.",
    ],
  },
  {
    title: "Information Technology And Services Consultant",
    company: "Vortnet Digital",
    start_date: "Jan 2023",
    end_date: "Dec 2024",
    duties: [
      "Built WordPress websites using custom themes (PHP, JavaScript).",
      "Implemented IT solutions—including software/system upgrades, backups, and security enhancements—to streamline operations.",
      "Worked closely with stakeholders to gather requirements and integrate tailored IT services.",
    ],
  },
  {
    title: "Software Developer",
    company: "Data with Intelligence Lab (MUBAS)",
    start_date: "Dec 2022",
    end_date: "Feb 2023",
    duties: [
      "Gathered and refined technical specifications to inform system development and design effective data/process models.",
      "Developed and reviewed source code collaboratively to ensure robust and scalable solutions.",
    ],
  },
];
